import { PawIcon } from "./Paws";

const PHRASES = [
    "Mākara Village Boarding Cattery",
    "More than 20 years of family care",
    "Family-run · Mākara · Wellington",
    "Safety · Cleanliness · Happiness · Care",
    "Peaceful country surroundings",
];

const Row = ({ hidden }) => (
    <div
        className="flex shrink-0 items-center gap-10 pr-10"
        aria-hidden={hidden ? "true" : undefined}
    >
        {PHRASES.map((p) => (
            <span key={p} className="flex items-center gap-10">
                <span className="whitespace-nowrap font-serif text-lg sm:text-xl italic text-cream/90">
                    {p}
                </span>
                <PawIcon className="h-4 w-4 shrink-0 text-cream/40" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        className="overflow-hidden border-y border-black/10 bg-moss py-5"
        data-testid="editorial-marquee"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row hidden />
        </div>
    </div>
);
